<app-ark-container
  [future]="dataObservable"
  [loadingTemplate]="loading"
  [successTemplate]="success"
  [failureTemplate]="failure"
  [errorTemplate]="error"
  (onSuccess)="onAnalystDataResolved($event[0])"
>
</app-ark-container>
<ng-template #loading>
  <div id="analystModel" class="section">
    <div class="header">
      <div class="header-text header-2">
        <span>Analyst Models</span>
      </div>
    </div>
    <ul>
      <li *ngFor="let dummySection of [0, 1, 2, 3, 4, 5, 6, 7]">
        <nz-skeleton
          [nzTitle]="true"
          [nzActive]="true"
          [nzParagraph]="false"
        ></nz-skeleton>
      </li>
    </ul>
  </div>
</ng-template>
<ng-template #failure>
  <div class="error-container">
    <div class="error-msg">
      <va-icon name="info-circle" class="info-icon"></va-icon>
      <span class="error-text">{{ errorMsg }}</span>
    </div>
  </div>
</ng-template>
<ng-template #error>
  <div class="error-container">
    <div class="error-msg">
      <va-icon name="info-circle" class="info-icon"></va-icon>
      <span class="error-text">{{ errorMsg }}</span>
    </div>
  </div>
</ng-template>
<ng-template #success>
  <div id="analystModel" class="section">
    <div class="header">
      <div class="header-text header-2">
        <span>Analyst Models</span>
      </div>
      <!-- <div class="extra-info">
        <span>{{ extraInfo }}</span>
      </div> -->
    </div>
    <div class="analyst-model-table">
      <!-- add nz table with sort, row expansion, nested table, scroll -->
      <nz-table
        #nestedTable
        [nzData]="analystModelData"
        [nzBordered]="false"
        [nzFrontPagination]="false"
        [nzShowPagination]="false"
        [nzScroll]="{ x: '850px', y: '509px' }"
      >
        <thead>
          <tr>
            <th
              nzShowSort="true"
              nzAlign="left"
              nzWidth="20%"
              class="broker-col"
              (nzSortOrderChange)="getSortedData($event, 'brokerShortName')"
              [nzSortDirections]="columnSortDirections"
              [nzSortFn]="true"
            >
              Broker
            </th>
            <th class="waterfront-col" nzWidth="2%"></th>
            <!-- row expansion -->

            <th
              nzShowSort="true"
              nzAlign="left"
              nzWidth="17%"
              class="analyst-col"
              (nzSortOrderChange)="getSortedData($event, 'analyst')"
              [nzSortDirections]="columnSortDirections"
              [nzSortFn]="true"
            >
              Analyst
            </th>

            <th
              nzShowSort="true"
              nzAlign="left"
              nzWidth="20%"
              class="event-date-col"
              (nzSortOrderChange)="getSortedData($event, 'consensusStatus')"
              [nzSortDirections]="columnSortDirections"
              [nzSortFn]="true"
            >
              Consensus Status
            </th>

            <th class="expand-col" nzWidth="2%"></th>
            <th
              nzShowSort="true"
              nzAlign="left"
              nzWidth="19%"
              class="event-date-col"
              (nzSortOrderChange)="getSortedData($event, 'eventDate')"
              [nzSortDirections]="columnSortDirections"
              [nzSortFn]="true"
            >
              Date Published
            </th>
            <th nzWidth="13%" class="model-archive-col">Model</th>
            <th nzWidth="8%" class="view-col">Link</th>
            <!-- <th nzWidth="8%" class="total-models-col"> -->
            <!-- model count -->
            <!-- </th> -->
          </tr>
        </thead>
        <tbody>
          <ng-template ngFor let-row [ngForOf]="analystModelData">
            <tr *ngIf="row.fields === 'all'">
              <td
                class="broker-col"
                [ngClass]="{
                  'hide-border': row.expand
                }"
              >
                <!-- broker page present and not earnings -->
                <div *ngIf="row.showLink">
                  <span title="{{ row.brokerFullName }}" class="broker-name">
                    <a
                      routerLink="/reporting/broker/{{ row.brokerShortName }}"
                      >{{ row.brokerShortName }}</a
                    >
                  </span>
                </div>
                <!-- broker page not present -->
                <div *ngIf="!row.showLink">
                  <span title="{{ row.brokerFullName }}" class="broker-name">
                    {{ row.brokerShortName }}
                  </span>
                </div>
              </td>
              <td class="waterfront-col">
                <div *ngIf="row.showWaterFront">
                  <span
                    title="{{ row.waterFrontTitle || 'NA' }}"
                    class="water-front-icon"
                  >
                    <!-- flag icon -->
                    <va-icon size="small" name="flag"></va-icon>
                  </span>
                </div>
              </td>
              <td class="analyst-col">
                <!-- analyst page present-->
                <div *ngIf="row.showLink" class="analyst-name">
                  <span
                    nz-popover
                    [nzPopoverContent]="contentTemplate"
                    nzPopoverTrigger="hover"
                    nzPopoverPlacement="right"
                    [nzPopoverOverlayClassName]="'analyst-popover'"
                  >
                    <a
                      routerLink="/reporting/analyst/{{ row.subRow.analystId }}"
                      routerLinkActive="active"
                      >{{ row.subRow.analystName | textEllipsis: 15 }}</a
                    >
                  </span>
                </div>
                <!-- analyst page not present -->
                <div *ngIf="!row.showLink" class="analyst-name">
                  <span>
                    {{ row.subRow.analystName | textEllipsis: 15 }}
                  </span>
                </div>
              </td>

              <td class="consensus-status-col">
                <div class="display-flex flex-align-center">
                  <span
                    *ngIf="
                      companyFlag != 1 &&
                      row.consensusStatus &&
                      row.brokerPriorityText !== 'Prioritize' &&
                      !(
                        row.brokerPriorityText == 'Not Processed' &&
                        row.awaiting_process_disabled == true
                      )
                    "
                  >
                    <span class="consensus-col-space"> </span>
                    {{ row.consensusStatus }}
                  </span>

                  <div
                    class="prioritizeDiv"
                    *ngIf="
                      row.brokerPrioritized &&
                      companyFlag != 1 &&
                      row.consensusStatus != 'Current' &&
                      row.consensusStatus != 'Not Current'
                    "
                  >
                    <div
                      *ngIf="row.brokerPriorityText == 'Prioritize'"
                      (click)="bindPrioritize(row.brokerShortName)"
                    >
                      <img
                        [src]="assets + '/prioritize-icon.png'"
                        class="prioritize-icon"
                      />
                      <span class="prioritize-analyst">{{
                        row.consensusStatus
                      }}</span>
                    </div>

                    <div
                      *ngIf="
                        row.brokerPriorityText == 'Not Processed' &&
                        row.awaiting_process_disabled == true
                      "
                    >
                      <img
                        [src]="assets + '/disabled-priortize-icon.svg'"
                        class="prioritize-icon-disabled"
                      />
                      <span class="prioritize-analyst-disabled">
                        {{ row.consensusStatus }}</span
                      >
                    </div>
                  </div>

                  <va-icon
                    *ngIf="
                      ((row.subRow.isInProgress &&
                        (row.subRow.transactionStatus === 'On-Hold' ||
                          row.subRow.transactionStatus === 'Not Processed')) ||
                        (row.brokerPriorityText !== 'Prioritize' &&
                          (row.brokerPriorityText === 'Not Processed' ||
                            row.brokerPriorityText === 'On-Hold')) ||
                        row.subRow.transactionStatus === 'In Progress') &&
                      (row.consensusStatus == 'Current' ||
                        row.consensusStatus == 'Not Current')
                    "
                    name="info-circle"
                    class="model-info-icon-blue"
                    nz-popover
                    [nzPopoverTitle]="currentTitle"
                    [nzPopoverContent]="currentTemplate"
                    nzPopoverTrigger="hover"
                    nzPopoverPlacement="right"
                    nzPopoverWidth="20px"
                    nzPopoverOverlayClassName="analyst-model-tooltip"
                  ></va-icon>

                  <va-icon
                    *ngIf="
                      !(
                        (row.subRow.isInProgress &&
                          (row.subRow.transactionStatus === 'On-Hold' ||
                            row.subRow.transactionStatus ===
                              'Not Processed')) ||
                        (row.brokerPriorityText !== 'Prioritize' &&
                          (row.brokerPriorityText === 'Not Processed' ||
                            row.brokerPriorityText === 'On-Hold')) ||
                        row.subRow.transactionStatus === 'In Progress'
                      ) && row.consensusStatus == 'Not Current'
                    "
                    name="close-circle"
                    class="not-current-cross-icon"
                    nz-popover
                    [nzPopoverTitle]="notCurrentTitle"
                    [nzPopoverContent]="notCurrentTemplate"
                    nzPopoverTrigger="hover"
                    nzPopoverPlacement="right"
                    nzPopoverWidth="20px"
                    [nzPopoverOverlayClassName]="'analyst-popover'"
                  ></va-icon>

                  <va-icon
                    *ngIf="
                      row.consensusStatus == 'Current' &&
                      row.subRow.isReaffirm == true
                    "
                    [isFontAwesome]="true"
                    [name]="faRegisterdLight"
                    nz-popover
                    class="reaffirm-icon"
                    [nzPopoverTitle]="reaffirmTitle"
                    [nzPopoverContent]="reaffirmTemplate"
                    nzPopoverTrigger="hover"
                    nzPopoverPlacement="right"
                    nzPopoverWidth="20px"
                    nzPopoverOverlayClassName="reaffirm-popover"
                  ></va-icon>
                </div>
                <ng-template #reaffirmTitle>
                  <span>
                    <b>Reaffirmed </b>
                  </span>
                </ng-template>
                <ng-template #reaffirmTemplate>
                  <span *ngIf="row.subRow.reaffirmType == 0">
                    This model is reincluded in consensus because the broker
                    republished the model on:
                    {{ row.subRow.effectivestart | date: "dd MMM yyyy" }}
                  </span>
                  <span *ngIf="row.subRow.reaffirmType == 1">
                    This model is reincluded in consensus because the broker
                    reaffirmed it on:
                    {{ row.subRow.effectivestart | date: "dd MMM yyyy" }}
                  </span>

                  <span>
                    <br />
                    <a [href]="reaffirmedSupportLink" target="_blank">
                      Learn More
                    </a>
                  </span>
                </ng-template>

                <ng-template #currentTitle>
                  <span>
                    <b>Uses Previous Model </b>
                  </span>
                </ng-template>
                <ng-template #currentTemplate>
                  <span>
                    See notes under model column for processing status of the
                    latest model.
                  </span>
                </ng-template>

                <ng-template #notCurrentTitle>
                  <span>
                    <b>Older Than Cutoff </b>
                  </span>
                </ng-template>
                <ng-template #notCurrentTemplate>
                  <span>
                    The last processed model is <br />
                    older than earnings.
                    <br /></span
                  ><span>
                    <span class="display-flex flex-align-center">
                      <va-icon
                        *ngIf="row.subRow.analystEmail"
                        [name]="faEnvelope"
                        isFontAwesome="true"
                        class="fal"
                      ></va-icon>
                      <a
                        href="mailto:{{ row.subRow.analystEmail }}"
                        class="email"
                      >
                        {{ row.subRow.analystEmail }}</a
                      >
                    </span>
                  </span>
                </ng-template>
              </td>

              <td
                *ngIf="row.totalModels > 1"
                [nzShowExpand]="row.totalModels > 1"
                [(nzExpand)]="row.expand"
                (nzExpandChange)="expandRow(row, false)"
                class="expand-col"
                title="Show Older Models"
              ></td>
              <td
                *ngIf="row.totalModels <= 1"
                [nzShowExpand]="row.totalModels > 1"
                [(nzExpand)]="row.expand"
                (nzExpandChange)="expandRow(row, false)"
                class="expand-col"
              ></td>
              <td class="event-date-col">
                <ng-container
                  [ngTemplateOutlet]="eventDatePopover"
                  [ngTemplateOutletContext]="{
                    sourceId: row.sourceId,
                    row: row.subRow
                  }"
                >
                </ng-container>
              </td>

              <td class="model-archive-col">
                <!--row.subRow.fileSize this check is used for filings -->
                <!-- Source level entitled and transaction level allowed -->
                <div class="display-flex flex-align-center">
                  <span
                    class="model-download"
                    *ngIf="
                      row.entitledModel == true &&
                      row.subRow.fileSize &&
                      row.subRow.downloadApplicable == true
                    "
                    (click)="
                      modelDownloadClick(row.subRow, row.brokerShortName)
                    "
                    title="Download {{ row.subRow.fileName }}"
                  >
                    <va-icon
                      size="small"
                      name="file-excel"
                      class="excel-icon"
                    ></va-icon>
                    <span> ({{ row.subRow.fileSize }})</span>
                  </span>

                  <!-- Source level entitled and transaction level NOT allowed -->
                  <span
                    class="model-download disabled-model"
                    *ngIf="
                      row.entitledModel == true &&
                      row.subRow.fileSize &&
                      row.subRow.downloadApplicable == false
                    "
                    title="A downloadable model is not currently available"
                  >
                    <va-icon
                      size="small"
                      name="file-excel"
                      class="excel-icon"
                    ></va-icon>
                    <span> ({{ row.subRow.fileSize }})</span>
                  </span>

                  <!-- Source level not entitled -->
                  <span
                    class="model-download disabled-model"
                    *ngIf="row.entitledModel == false && row.subRow.fileSize"
                    title="Not entitled"
                  >
                    <va-icon
                      size="small"
                      name="file-excel"
                      class="excel-icon"
                    ></va-icon>
                    <span> ({{ row.subRow.fileSize }})</span>
                  </span>
                  <va-icon
                    *ngIf="
                      row.brokerPriorityText !== 'Prioritize' &&
                      ((row.subRow.isInProgress == true &&
                        row.subRow.transactionStatus === 'On-Hold') ||
                        row.brokerPriorityText === 'On-Hold')
                    "
                    name="clock"
                    class="onhold-icon duplicate"
                    nz-popover
                    [nzPopoverTitle]="onHoldTitle"
                    [nzPopoverContent]="onHoldTemplate"
                    nzPopoverTrigger="hover"
                    nzPopoverPlacement="right"
                    nzPopoverWidth="20px"
                    nzPopoverOverlayClassName="analyst-model-tooltip"
                  ></va-icon>
                  <ng-template #onHoldTitle>
                    <span>
                      <b> On Hold</b>
                    </span>
                  </ng-template>
                  <ng-template #onHoldTemplate>
                    <span *ngIf="row.brokerPrioritizedComment">
                      {{ row.brokerPrioritizedComment }}
                    </span>
                    <span *ngIf="row.subRow.transactionComment">
                      {{ row.subRow.transactionComment }}
                    </span>
                  </ng-template>

                  <va-icon
                    *ngIf="
                      row.subRow.isInProgress &&
                      row.subRow.transactionStatus === 'In Progress'
                    "
                    size="small"
                    name="sync"
                    class="in-progress-icon ml-4"
                    nz-popover
                    [nzPopoverTitle]="inProgressTitle"
                    [nzPopoverContent]="inProgressTemplate"
                    nzPopoverTrigger="hover"
                    nzPopoverPlacement="right"
                    nzPopoverWidth="20px"
                    nzPopoverOverlayClassName="analyst-model-tooltip"
                  ></va-icon>
                  <ng-template #inProgressTitle>
                    <span>
                      <b>In Progress</b>
                    </span>
                  </ng-template>
                  <ng-template nzWidth="10%" #inProgressTemplate>
                    <span> Consensus processing is in progress </span>
                  </ng-template>
                  <va-icon
                    *ngIf="
                      row.brokerPriorityText !== 'Prioritize' &&
                      ((row.subRow.isInProgress === true &&
                        row.subRow.transactionStatus === 'Not Processed') ||
                        row.brokerPriorityText === 'Not Processed')
                    "
                    name="minus-circle"
                    class="not-processed-icon duplicate"
                    nz-popover
                    [nzPopoverTitle]="notProcessedTitle"
                    [nzPopoverContent]="notProcessedTemplate"
                    nzPopoverTrigger="hover"
                    nzPopoverPlacement="right"
                    nzPopoverOverlayClassName="analyst-model-tooltip"
                  ></va-icon>
                  <ng-template #notProcessedTitle>
                    <span *ngIf="row.brokerPriorityText">
                      <b>{{ row.brokerPriorityText }}</b>
                    </span>
                    <span *ngIf="row.subRow.transactionStatus">
                      <b>{{ row.subRow.transactionStatus }}</b>
                    </span>
                  </ng-template>
                  <ng-template #notProcessedTemplate>
                    <span *ngIf="row.brokerPrioritizedComment">
                      {{ row.brokerPrioritizedComment }}
                    </span>
                    <span *ngIf="row.subRow.transactionComment">
                      {{ row.subRow.transactionComment }}
                    </span>
                  </ng-template>
                </div>
              </td>
              <td class="view-col">
                <div>
                  <a
                    title="View this model on the web"
                    *ngIf="row.subRow.showViewLink"
                    routerLink="{{
                      '/mex/' +
                        ticker +
                        '/SAR/' +
                        row.subRow.pg +
                        '/' +
                        row.brokerShortName
                    }}"
                  >
                    Data
                    <va-icon
                      name="info-circle"
                      *ngIf="row.showAsReported"
                      title="As Reported Only"
                    ></va-icon>
                  </a>
                </div>

                <!-- Not adding link for 'on hold' broker state -->
              </td>

              <ng-template #contentTemplate>
                <div>
                  <a
                    routerLink="/reporting/analyst/{{ row.subRow.analystId }}"
                    routerLinkActive="active"
                    class="name"
                    >{{ row.subRow.analystName }}</a
                  ><br />
                  <a
                    routerLink="/reporting/broker/{{ row.brokerShortName }}"
                    class="broker"
                    >{{ row.brokerFullName }} Home</a
                  ><br />
                  <a href="mailto:{{ row.subRow.analystEmail }}" class="email">
                    {{ row.subRow.analystEmail }}</a
                  >
                </div>
              </ng-template>
            </tr>
            <tr *ngIf="row.fields === 'earnings'">
              <!-- earnings row -->
              <td
                class="broker-col"
                [ngClass]="{
                  'hide-border': row.expand
                }"
              >
                <div>
                  <span class="broker-name"> Company Announcements </span>
                </div>
              </td>
              <td class="waterfront-col">
                <div *ngIf="row.showWaterFront">
                  <span
                    title="{{ row.waterFrontTitle || 'NA' }}"
                    class="water-front-icon"
                  >
                    <!-- flag icon -->
                    <va-icon name="flag"></va-icon>
                  </span>
                </div>
              </td>

              <td class="analyst-col">
                <div>
                  <span class="broker-name">
                    {{ row.documentType.document_type }}
                  </span>
                </div>
              </td>

              <td class="event-date-col">
                <!-- consensus status  -->
              </td>

              <td
                *ngIf="row.totalModels > 1"
                [nzShowExpand]="row.totalModels > 1"
                [(nzExpand)]="row.expand"
                (nzExpandChange)="expandRow(row, false)"
                class="expand-col"
                title="Show Older Models"
              ></td>
              <td
                *ngIf="row.totalModels <= 1"
                [nzShowExpand]="row.totalModels > 1"
                [(nzExpand)]="row.expand"
                (nzExpandChange)="expandRow(row, false)"
                class="expand-col"
              ></td>
              <td class="event-date-col filings-date">
                <ng-container
                  [ngTemplateOutlet]="eventDatePopover"
                  [ngTemplateOutletContext]="{
                    row: row.subRow,
                    statedperiodtooltip: row.statedperiodtooltip,
                    documentType: row.documentType.document_type
                  }"
                >
                </ng-container>
                <!-- <span> -->
                <va-icon
                  [name]="'guidance'"
                  class="data-setting-icon guidance-icon"
                  size="small"
                  nz-popover
                  nzPopoverContent="Guidance is available in this document, click on Filings to view"
                  nzPopoverTrigger="hover"
                  nzPopoverPlacement="right"
                  *ngIf="row.documentType.guidance"
                ></va-icon>
                <!-- </span> -->
              </td>
              <td class="model-archive-col"></td>
              <td class="view-col">
                <div>
                  <!-- ng-click="openFilings(row.earningsData)" -->
                  <span
                    *ngIf="row.earningsData.document_id"
                    class="view-link"
                    (click)="openFilings(row, false, false)"
                  >
                    Filing
                  </span>
                </div>
              </td>

              <!-- <td class="total-models-col"></td> -->
            </tr>

            <tr *ngIf="row.fields === 'interim'">
              <!-- earnings row -->
              <td
                class="broker-col"
                [ngClass]="{
                  'hide-border': row.expand
                }"
              >
                <div>
                  <span class="broker-name"> Company Announcements </span>
                </div>
              </td>
              <td class="waterfront-col">
                <div *ngIf="row.showWaterFront">
                  <span
                    title="{{ row.waterFrontTitle || 'NA' }}"
                    class="water-front-icon"
                  >
                    <!-- flag icon -->
                    <va-icon name="flag"></va-icon>
                  </span>
                </div>
              </td>

              <td class="analyst-col">
                <div>
                  <span class="broker-name"> Interim Release </span>
                </div>
              </td>

              <td class="event-date-col">
                <!-- consensus status  -->
              </td>

              <td
                *ngIf="row.totalModels > 1"
                [nzShowExpand]="row.totalModels > 1"
                [(nzExpand)]="row.expand"
                (nzExpandChange)="expandRow(row, false)"
                class="expand-col"
                title="Show Older Models"
              ></td>
              <td
                *ngIf="row.totalModels <= 1"
                [nzShowExpand]="row.totalModels > 1"
                [(nzExpand)]="row.expand"
                (nzExpandChange)="expandRow(row, false)"
                class="expand-col"
              ></td>
              <td class="event-date-col filings-date">
                <ng-container
                  [ngTemplateOutlet]="eventDatePopover"
                  [ngTemplateOutletContext]="{
                    row: row.subRow,
                    statedperiodtooltip: row.statedperiodtooltip,
                    documentType: row.documentType.document_type
                  }"
                >
                </ng-container>
                <va-icon
                  [name]="'guidance'"
                  class="data-setting-icon guidance-icon"
                  size="small"
                  nz-popover
                  nzPopoverContent="Guidance is available in this document, click on Filings to view"
                  nzPopoverTrigger="hover"
                  nzPopoverPlacement="right"
                  *ngIf="row.documentType.guidance"
                ></va-icon>
              </td>
              <td class="model-archive-col"></td>
              <td class="view-col">
                <div>
                  <!-- ng-click="openFilings(row.earningsData)" -->

                  <span
                    *ngIf="row.interimData.document_id"
                    class="view-link"
                    (click)="openFilings(row, false, true)"
                  >
                    Filing
                  </span>
                </div>
              </td>

              <!-- <td class="total-models-col"></td> -->
            </tr>
            <!-- dropped and not current row -->
            <tr
              *ngIf="
                row.fields === 'notCurrentModel' ||
                row.fields === 'droppedCoverage'
              "
            >
              <td
                class="broker-col"
                [ngClass]="{
                  'hide-border': row.expand
                }"
              >
                <div *ngIf="row.showLink">
                  <span title="{{ row.brokerFullName }}" class="broker-name">
                    <a
                      routerLink="/reporting/broker/{{ row.brokerShortName }}"
                      >{{ row.brokerShortName }}</a
                    >
                  </span>
                </div>
                <!-- broker page not present -->
                <div *ngIf="!row.showLink">
                  <span title="{{ row.brokerFullName }}" class="broker-name">
                    {{ row.brokerShortName }}
                  </span>
                </div>
              </td>
              <td class="waterfront-col">
                <div *ngIf="row.showWaterFront">
                  <span
                    title="{{ row.waterFrontTitle || 'NA' }}"
                    class="water-front-icon"
                  >
                    <!-- flag icon -->
                    <va-icon size="small" name="flag"></va-icon>
                  </span>
                </div>
              </td>
              <td>
                <!-- analyst name  -->
              </td>
              <td>
                <!-- consesnsus status -->
              </td>
              <td
                *ngIf="row.totalModels > 1"
                [nzShowExpand]="row.totalModels > 1"
                [(nzExpand)]="row.expand"
                (nzExpandChange)="expandRow(row, false)"
                class="expand-col"
                title="Show Older Models"
              ></td>
              <td
                *ngIf="row.totalModels <= 1"
                [nzShowExpand]="row.totalModels > 1"
                [(nzExpand)]="row.expand"
                (nzExpandChange)="expandRow(row, false)"
                class="expand-col"
              ></td>
              <td class="event-date-col" colspan="5">
                <div *ngIf="row.isDropCoverage">
                  <ng-container
                    [ngTemplateOutlet]="eventDatePopover"
                    [ngTemplateOutletContext]="{
                      row: row.subRow,
                      columnData: 'Dropped Coverage'
                    }"
                  >
                  </ng-container>
                </div>
                <div *ngIf="row.isNotCurrentModel">
                  <ng-container
                    [ngTemplateOutlet]="eventDatePopover"
                    [ngTemplateOutletContext]="{
                      row: row.subRow,
                      columnData: 'No Current Model'
                    }"
                  >
                  </ng-container>
                </div>
              </td>
            </tr>
            <tr [nzExpand]="row.expand" class="expansion-row">
              <!-- <div
                colspan="8"
                class="expansion-td"

                *ngIf="row.innerTable.data && row.innerTable.data.length"
              > -->
              <!--<td colspan="5" class="expansion-td"> -->
              <nz-table
                *ngIf="row.innerTable.data && row.innerTable.data.length"
                #innerTable
                [nzData]="row.innerTable"
                [nzFrontPagination]="false"
                [nzShowPagination]="false"
                [nzBordered]="false"
                [nzScroll]="{ x: '100%' }"
              >
                <thead>
                  <tr class="hide">
                    <th
                      nzShowSort="true"
                      nzAlign="left"
                      nzSortKey="brokerShortName"
                      nzWidth="20%"
                      class="broker-col"
                    >
                      Broker
                    </th>
                    <th class="waterfront-col" nzWidth="2%"></th>
                    <th nzAlign="left" nzWidth="17%" class="analyst-col"></th>
                    <th
                      nzAlign="left"
                      nzWidth="20%"
                      class="consensus-status-col"
                    >
                      <!-- consensus status -->
                    </th>
                    <!-- row expansion -->
                    <th class="expand-col" nzWidth="2%"></th>
                    <th
                      nzAlign="left"
                      nzWidth="22%"
                      class="event-date-col"
                    ></th>

                    <th nzWidth="13%" class="model-archive-col"></th>
                    <th nzWidth="8%" class="view-col"></th>
                    <!-- <th nzWidth="8%" class="total-models-col"> -->
                    <!-- model count -->
                    <!-- </th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let innerRow of row.innerTable.data;
                      index as i;
                      first as isFirst;
                      last as isLast
                    "
                  >
                    <td class="broker-col">
                      <span>&nbsp;</span>
                    </td>
                    <td class="waterfront-col">
                      <span>&nbsp;</span>
                    </td>

                    <td class="analyst-col">
                      <div
                        *ngIf="
                          row.fields == 'earnings' && row.countryid == '88'
                        "
                      >
                        {{ innerRow.documentType }}
                      </div>
                      <div
                        class="analyst-name"
                        *ngIf="
                          row.fields === 'all' &&
                          (row.fields !== 'earnings' || !isFirst)
                        "
                      >
                        <span>
                          {{ innerRow.analystName | textEllipsis: 15 }}
                        </span>
                      </div>
                      <div
                        class="analyst-name"
                        *ngIf="
                          isFirst &&
                          (row.fields === 'notCurrentModel' ||
                            row.fields == 'droppedCoverage')
                        "
                      >
                        <div *ngIf="row.showLink" class="analyst-name">
                          <span>
                            <a
                              routerLink="/reporting/analyst/{{
                                innerRow.analystId
                              }}"
                              routerLinkActive="active"
                              >{{ innerRow.analystName | textEllipsis: 15 }}</a
                            >
                          </span>
                        </div>
                        <!-- analyst page not present -->
                        <div *ngIf="!row.showLink" class="analyst-name">
                          <span>
                            {{ innerRow.analystName | textEllipsis: 15 }}
                          </span>
                        </div>
                      </div>
                    </td>

                    <td class="consensus-status-col">
                      <!-- consensus status -->
                    </td>

                    <td
                      [nzShowExpand]="
                        isLast &&
                        row.innerTable.data.length > 0 &&
                        row.innerTable.showMoreCount > 0
                      "
                      class="expand-col"
                      (nzExpandChange)="expandRow(row, true)"
                      title="SHOW {{ row.innerTable.showMoreCount }} MORE"
                    ></td>
                    <td class="event-date-col padder filings-date">
                      <ng-container
                        [ngTemplateOutlet]="eventDatePopoverInner"
                        [ngTemplateOutletContext]="{
                          sourceId: row.sourceId,
                          row: innerRow,
                          statedperiodtooltip: innerRow.statedperiodtooltip,
                          documentType: row.documentType
                        }"
                      >
                      </ng-container>
                      <va-icon
                        [name]="'guidance'"
                        class="data-setting-icon guidance-icon"
                        size="small"
                        nz-popover
                        nzPopoverContent="Guidance is available in this document, click on Filings to view"
                        nzPopoverTrigger="hover"
                        nzPopoverPlacement="right"
                        *ngIf="innerRow.guidance"
                      ></va-icon>
                    </td>

                    <td class="model-archive-col remove-padder">
                      <!--innerRow.fileSize this check is used for filings -->
                      <!-- Source level entitled and transaction level allowed -->
                      <div
                        class="model-download"
                        *ngIf="
                          row.entitledModel == true &&
                          innerRow.fileSize &&
                          innerRow.downloadApplicable == true
                        "
                        (click)="
                          modelDownloadClick(innerRow, row.brokerShortName)
                        "
                        title="Download {{ innerRow.fileName }}"
                      >
                        <va-icon
                          size="small"
                          name="file-excel"
                          class="excel-icon"
                        ></va-icon>
                        <span> ({{ innerRow.fileSize }})</span>
                      </div>

                      <!-- Source level entitled and transaction level NOT allowed -->
                      <div
                        class="model-download disabled-model"
                        *ngIf="
                          row.entitledModel == true &&
                          innerRow.fileSize &&
                          innerRow.downloadApplicable == false
                        "
                        title="A downloadable model is not currently available"
                      >
                        <va-icon
                          size="small"
                          name="file-excel"
                          class="excel-icon"
                        ></va-icon>
                        <span> ({{ innerRow.fileSize }})</span>
                      </div>

                      <!-- Source level not entitled -->
                      <div
                        class="model-download disabled-model"
                        *ngIf="row.entitledModel == false && innerRow.fileSize"
                        title="Not entitled"
                      >
                        <va-icon
                          size="small"
                          name="file-excel"
                          class="excel-icon"
                        ></va-icon>
                        <span> ({{ innerRow.fileSize }})</span>
                      </div>
                    </td>

                    <td class="view-col">
                      <!-- view link shown only if drop coverage or else blank -->
                      <div
                        *ngIf="
                          isFirst &&
                          (row.fields === 'notCurrentModel' ||
                            row.fields == 'droppedCoverage')
                        "
                      >
                        <a
                          title="View this model on the web"
                          *ngIf="row.showViewLink"
                          routerLink="{{
                            '/mex/' +
                              ticker +
                              '/SAR/' +
                              row.subRow.pg +
                              '/' +
                              row.brokerShortName
                          }}"
                        >
                          Data
                          <va-icon
                            name="info-circle"
                            *ngIf="row.showAsReported"
                            title="As Reported Only"
                          ></va-icon>
                        </a>
                      </div>
                      <div *ngIf="innerRow.isInProgress">
                        <span title="{{ innerRow.transactionStatus }}">
                          {{ innerRow.transactionStatus | textEllipsis: 15 }}
                        </span>
                      </div>
                      <div *ngIf="row.fields === 'earnings'">
                        <span
                          *ngIf="innerRow.documentId"
                          class="view-link"
                          (click)="openFilings(innerRow, true, false)"
                        >
                          Filing
                        </span>
                      </div>
                      <div *ngIf="row.fields === 'interim'">
                        <span
                          *ngIf="innerRow.documentId"
                          class="view-link"
                          (click)="openFilings(innerRow, true, false)"
                        >
                          Filing
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </nz-table>
              <!-- </div> -->
            </tr>
          </ng-template>
        </tbody>
      </nz-table>
    </div>
    <div class="footer" *ngIf="footerText != ''">
      <div class="footer-text" title="{{ footerHoverMsg }}">
        <span>{{ footerText }}</span>
      </div>
    </div>
  </div>
  <!-- <nz-modal
    [(nzVisible)]="isViewModalVisible"
    [nzFooter]="null"
    nzWidth="800px"
    (nzOnCancel)="handleCancel()"
    nzWrapClassName="analyst-fillings-modal"
  >
   <div *nzModalTitle>   
    <div class="example-handle">

  </div> &nbsp; {{filingsHeading}}</div>
    <ng-container *nzModalContent>
      <div class="draggable-modal-wrapper">
        <div style="height: 300px" *ngIf="gettingPDFURL"></div>
        <div class="pagination-bar">
          <div class="doc-details">
            <div class="doc-type">
              <div class="detail-title">Document Type:</div>
              <div class="detail-value">{{ documentType }}</div>
            </div>
            <div class="date-pub">
              <div class="detail-title">Date Published:</div>
              <div class="detail-value">{{ datePublish }}</div>
            </div>
          </div>
          <div class="guidance-navigation" *ngIf="hasGuidance">
            <div class="guidance-title">
              <va-icon
                [name]="'guidance'"
                size="medium"
                class="data-setting-icon guidance-icon"
              ></va-icon>
              Guidance
            </div>
            <div class="guidance-navigator">
              <va-icon
                [name]="'chevron-left'"
                class="data-setting-icon navigator-element"
                size="small"
                (click)="onPrevGuidance()"
              ></va-icon>
              <div class="guidance-index">
                {{ currentGuidance }}
              </div>
              <div class="navigator-element">/</div>
              <div class="guidance-count navigator-element">
                {{ guidanceCount }}
              </div>
              <va-icon
                [name]="'chevron-right'"
                class="data-setting-icon navigator-element"
                size="small"
                (click)="onNextGuidance()"
              ></va-icon>
            </div>
          </div>
        </div>
        <iframe
          [src]="viewModalSrc"
          id="filingsFrame"
          frameborder="0"
          allowfullscreen
          width="100%"
          height="300px"
          *ngIf="filingFileType === 'pdf' && !filingsError && !gettingPDFURL"
        ></iframe>
        <iframe
          id="filingsFrame"
          frameborder="0"
          allowfullscreen
          width="100%"
          height="300px"
          *ngIf="
            (filingFileType === 'htm' || filingFileType === 'html') &&
            !filingsError
          "
        ></iframe>
        <div id="filings-error" class="error-container" *ngIf="filingsError">
          <div class="error-msg">
            <va-icon name="info-circle" class="info-icon"></va-icon>
            <span class="error-text">Filings not found</span>
          </div>
        </div>
      </div>
    </ng-container>
  </nz-modal> -->
</ng-template>

<ng-template
  #eventDatePopover
  let-sourceId="sourceId"
  let-row="row"
  let-columnData="columnData"
  let-statedperiodtooltip="statedperiodtooltip"
  let-documentType="documentType"
>
  <div class="display-flex flex-align-center">
    <span
      class="event-date"
      *ngIf="row.model_date !== undefined"
      nz-popover
      [nzPopoverTrigger]="'hover'"
      [nzPopoverPlacement]="'right'"
      [nzPopoverContent]="
        row.model_date
          ? 'Model date: ' +
            (row.model_date | date: 'dd-MMM-yy') +
            ' (' +
            row.dayDiff +
            ')'
          : 'Model date: Not available'
      "
      class="event-date"
    >
      <span *ngIf="columnData">{{ columnData }} </span>
      <span *ngIf="!columnData"
        >{{ row.eventDate | date: "dd-MMM-yy" }} ({{ row.dayDiff }})
      </span>
    </span>
    <span
      *ngIf="row.model_date === undefined && statedperiodtooltip === undefined"
      class="event-date"
    >
      <span *ngIf="columnData">{{ columnData }} </span>
      <span *ngIf="!columnData"
        >{{ row.eventDate | date: "dd-MMM-yy" }} ({{ row.dayDiff }})
      </span>
    </span>
    <span
      *ngIf="statedperiodtooltip"
      nz-popover
      [nzPopoverTrigger]="'hover'"
      [nzPopoverPlacement]="'right'"
      [nzPopoverContent]="statedperiodtooltip"
      class="event-date"
    >
      <span *ngIf="!columnData"
        >{{ row.eventDate | date: "dd-MMM-yy " }} ({{ row.dayDiff }})
      </span>
    </span>
    <span *ngIf="row.hasDuplicate" class="flex-align-center">
      <va-icon
        [name]="faRegistered"
        isFontAwesome="true"
        class="model-info-icon duplicate top-4"
        *ngIf="
          row.hasDuplicate && (columnData == ' ' || columnData == undefined)
        "
        nz-popover
        [nzPopoverContent]="duplicateTemplate"
        nzPopoverTrigger="hover"
        nzPopoverPlacement="right"
        (mouseover)="getDuplicateMsg(sourceId, row)"
      ></va-icon>
      <ng-template #duplicateTemplate>
        <div>This model was republished on</div>
        <span class="duplicate-date" *ngFor="let date of row.duplicateList">
          <span>{{ date }}</span
          ><br />
        </span>
      </ng-template>
    </span>
  </div>
</ng-template>

<ng-template
  #eventDatePopoverInner
  let-sourceId="sourceId"
  let-row="row"
  let-columnData="columnData"
>
  <div>
    <span
      *ngIf="row.statedperiodtooltip"
      nz-popover
      [nzPopoverTrigger]="'hover'"
      [nzPopoverPlacement]="'right'"
      [nzPopoverContent]="row.statedperiodtooltip"
      class="event-date"
    >
      <span *ngIf="!columnData"
        >{{ row.eventDate | date: "dd-MMM-yy " }} ({{ row.dayDiff }})
      </span>
    </span>
    <span
      class="event-date"
      *ngIf="row.model_date !== undefined"
      nz-popover
      [nzPopoverTrigger]="'hover'"
      [nzPopoverPlacement]="'right'"
      [nzPopoverContent]="
        row.model_date
          ? 'Model date: ' +
            (row.model_date | date: 'dd-MMM-yy') +
            ' (' +
            row.dayDiff +
            ')'
          : 'Model date: Not available'
      "
      class="event-date"
    >
      <span *ngIf="columnData">{{ columnData }} </span>
      <span *ngIf="!columnData"
        >{{ row.eventDate | date: "dd-MMM-yy" }} ({{ row.dayDiff }})
      </span>
    </span>
    <span
      *ngIf="
        row.model_date === undefined &&
        (row.statedperiodtooltip === undefined ||
          row.statedperiodtooltip === ' ')
      "
      class="event-date"
    >
      <span *ngIf="columnData">{{ columnData }} </span>
      <span *ngIf="!columnData"
        >{{ row.eventDate | date: "dd-MMM-yy" }} ({{ row.dayDiff }})
      </span>
    </span>
    <va-icon
      [name]="faRegistered"
      isFontAwesome="true"
      class="model-info-icon duplicate"
      *ngIf="row.hasDuplicate && (columnData == ' ' || columnData == undefined)"
      nz-popover
      [nzPopoverContent]="duplicateTemplate"
      nzPopoverTrigger="hover"
      nzPopoverPlacement="right"
      (mouseover)="getDuplicateMsg(sourceId, row)"
    ></va-icon>
    <ng-template #duplicateTemplate>
      <div>This model was republished on</div>
      <span class="duplicate-date" *ngFor="let date of row.duplicateList">
        <span>{{ date }}</span
        ><br />
      </span>
    </ng-template>
  </div>
</ng-template>
